import { render, staticRenderFns } from "./Accusation.vue?vue&type=template&id=1df16655&"
import script from "./Accusation.vue?vue&type=script&lang=js&"
export * from "./Accusation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports